import { gql } from '@apollo/client';

const SAVE_TOUR_SETTING = gql`
  mutation SaveToursSettings($data: SaveToursSettingsInput!) {
    saveToursSettings(data: $data) {
      tourId
      tourStepSettings {
        viewed
      }
    }
  }
`;

export default SAVE_TOUR_SETTING;
